export const PermissionGroupData_SystemAdmin = {
    _id: 'a08d464b0cf42c4e42bcb67d03007df6',
    name: `System Admin`,
    uiLabel: `System Admin`,
};
export const PermissionGroupData_DevTeamMember = {
    _id: '4f169dbe6574ed75cc7b04a4c20da1a1',
    name: `Dev Team Member`,
    uiLabel: `Dev Team Member`,
};
export const PermissionGroupData_MedicalTeamMember = {
    _id: 'e6822acf068dca8015b0a235a6a481dd',
    name: `Medical Team Member`,
    uiLabel: `Medical Team Member`,
};
export const PermissionGroupData_GeneralQuaiStaff = {
    _id: '290d18681bef8264797dc516b836a37b',
    name: `General Quai Staff`,
    uiLabel: `General Quai Staff`,
};
export const PermissionGroupData_MedicalAnalyst = {
    _id: '9469fd3305aee9fee266528ce4aab961',
    name: `Medical Analyst`,
    uiLabel: `Medical Analyst`,
};
export const PermissionGroupData_MedicalStaff = {
    _id: '6ecbbe59447ba5c84ee834f0273909eb',
    name: `Medical Staff`,
    uiLabel: `Medical Staff`,
};
export const PermissionGroupData_All = [
    PermissionGroupData_SystemAdmin,
    PermissionGroupData_DevTeamMember,
    PermissionGroupData_MedicalTeamMember,
    PermissionGroupData_GeneralQuaiStaff,
    PermissionGroupData_MedicalAnalyst,
    PermissionGroupData_MedicalStaff,
];
//# sourceMappingURL=permission-groups.js.map